import React from 'react';
import Card from './Card';
import Title from '../Title';
import Slider from '../Slider';

// import S from './styled';

const plans = [
  {
    title: 'Bradesco',
    image: '/plans/bradesco.png',
    coverage: [
      'Terapia ABA',
      'Psicologia',
      'Fonoaudiologia',
      'Psicopedagogia',
      'Avaliação Neuropsicológica',
    ],
  },
  {
    title: 'Mediservice',
    image: '/plans/mediservice.png',
    coverage: [
      'Terapia ABA',
      'Psicologia',
      'Fonoaudiologia',
      'Psicopedagogia',
      'Avaliação Neuropsicológica',
    ],
  },
  {
    title: 'Cassi',
    image: '/plans/cassi.jpg',
    coverage: ['Fonoaudiologia', 'Psicologia'],
  },
  {
    title: 'Vivest',
    image: '/plans/vivest.png',
    coverage: [
      'Terapia ABA',
      'Psicologia',
      'Fonoaudiologia',
      'Psicopedagogia',
      'Avaliação Neuropsicológica',
    ],
  },
  {
    title: 'Geap',
    image: '/plans/geap.jpg',
    coverage: ['Fonoaudiologia', 'Psicologia'],
  },
  {
    title: 'Gama',
    image: '/plans/gama.jpg',
    coverage: ['Fonoaudiologia', 'Psicologia'],
  },
  {
    title: 'Postal Saúde',
    image: '/plans/postal.jpg',
    coverage: ['Psicologia', 'Fonoaudiologia'],
  },
  {
    title: 'EVO Saúde',
    image: '/plans/evo.jpg',
    coverage: ['Psicologia', 'Fonoaudiologia'],
  },
  {
    title: 'Doutor 123',
    image: '/plans/doutor123.jpg',
    coverage: ['Psicologia', 'Orientação Vocacional'],
  },
  {
    title: 'CAASP',
    image: '/plans/caasp.jpg',
    coverage: ['Fonoaudiologia', 'Psicologia'],
  },
  {
    title: 'Amil',
    image: '/plans/amil.png',
    coverage: ['Fonoaudiologia', 'Psicologia', 'Nutrólogo'],
    disclaimer: '* Não disponível no Núcleo Infantil Penha',
  },
  {
    title: 'Select Saúde',
    image: '/plans/select.png',
    coverage: ['Nutrólogo'],
  },
  {
    title: 'Seguros Unimed',
    image: '/plans/segurosunimed.png',
    coverage: ['Terapia ABA', 'Avaliação Neuropsicológica'],
  },
];

const Plans = () => (
  <section id="plans">
    <Title color="#186492" text="Planos de Saúde" />
    <Slider>
      {plans.map(({ title, image, coverage, disclaimer = null }) => (
        <Card key={title} title={title} items={coverage} image={image} disclaimer={disclaimer} />
      ))}
    </Slider>
  </section>
);

export default Plans;
